import { subDays, subHours } from 'date-fns'
let activityCount = 0
let folderCount = 0
let userCount = 0

/**
 * Returns a list of stubbed activity entities.
 * @return {Array}
 */
export function stubActivities () {
  activityCount = 0

  return [
    stubActivity({
      title: 'Open-ended title'
    }),
    stubActivity({
      title: 'Multiple choice title',
      type: 'multiple_choice_poll'
    }),
    stubActivity({
      title: 'Ranking title',
      type: 'ranking_poll'
    }),
    stubActivity({
      title: 'Q & A title',
      type: 'discourse'
    }),
    stubActivity({
      title: 'Clickable image title',
      type: 'clickable_image'
    }),
    stubActivity({
      title: 'Survey title',
      type: 'survey'
    }),
    stubActivity({
      title: 'Competition title',
      type: 'competition'
    }),
    stubActivity({
      title: 'A really long title name that never ends. '.repeat(10)
    }),
    stubActivity({
      title: '<em>Activated activity with formatting in title</em>',
      current: true
    }),
    stubActivity({
      title: 'Anonymous activity',
      anonymous: true
    }),
    stubActivity({
      title: 'Locked activity',
      state: 'closed'
    })
  ]
}

/**
 * Returns a list of stubbed folder entities.
 * @return {Array}
 */
export function stubFolders () {
  folderCount = 0

  return [
    stubFolder({ name: 'Zazzle zoo' }),
    stubFolder(),
    stubFolder({
      name: 'I am shared with others',
      shared_activity_groups: [{ id: 1000 }]
    }),
    stubFolder({ name: 'Dabble do' }),
    stubFolder()
  ]
}

/**
 * Returns a list of stubbed user entities.
 * @return {Array}
 */
export function stubUsers () {
  userCount = 0

  return [
    stubUser(),
    stubUser(),
    stubUser(),
    stubUser()
  ]
}

/**
 * Returns a list of stubbed shared folders entities.
 * @return {Array}
 */
export function stubShared () {
  folderCount = 0

  return [
    stubFolder({
      name: 'I have been shared with account',
      shared_activity_groups: [{
        recipient_group: { name: 'everyone at PE' },
        recipient_group_type: 'Account',
        sharer: { name: 'CEO' }
      }]
    }),
    stubFolder({
      shared_activity_groups: [{
        recipient_group: { name: 'Your team' },
        recipient_group_type: 'Team',
        sharer: { name: 'Small coach' }
      }]
    }),
    stubFolder({
      shared_activity_groups: [{
        recipient_group: { name: 'Your family' },
        recipient_group_type: 'Team',
        sharer: { name: 'Big brother' }
      }]
    })
  ]
}

// Serialized from => /api/activities
export function stubActivity (attrs = {}) {
  activityCount++

  return Object.assign({
    account_id: 10686239,
    anonymous: false,
    competition_id: null,
    created_at: '2020-06-18T12:53:52-07:00',
    current: false,
    group: { id: 9788542 },
    group_id: 9788542,
    id: activityCount,
    max_votes: null,
    owner_id: 12914396,
    permalink: 'H3fjhewMQzxFW6f8dT0bu',
    pinned: null,
    position: activityCount,
    registered_participants_only: false,
    results_count: activityCount * 10 + 1,
    shared_key: 'H3fjhewMQzxFW6f8dT0bu',
    shortcode: '22333',
    show_branding: true,
    simple_keywords: true,
    sms_enabled: true,
    start_at: null,
    state: 'opened',
    stop_at: null,
    survey_id: null,
    title: `Activity ${activityCount}`,
    type: 'free_text_poll',
    type_options: {},
    updated_at: subDays(new Date('2020-09-20T12:53:52-07:00'), activityCount).toString(),
    web_enabled: true
  }, attrs)
}

// Serialized from => /api/groups
export function stubFolder (attrs = {}) {
  folderCount++

  return Object.assign({
    // TODO: backend must add this updated_at field to API
    updated_at: subHours(new Date('2020-09-20T12:53:52-07:00'), folderCount * 10).toString(),
    account_id: 10686239,
    activities_count: folderCount * 3 + 1,
    collapsed: false,
    competitions_count: 0,
    id: folderCount,
    name: `Folder ${folderCount}`,
    next_group_id: null,
    owner: { name: 'Daniels Admin' },
    owner_id: 12914396,
    polls_count: 3,
    shared_activity_groups: [],
    surveys_count: 0,
    total_items: folderCount * 10 + 1
  }, attrs)
}

// Serialized from => /api/account_users
export function stubUser (attrs = {}) {
  userCount++

  return Object.assign({
    account_admin: true,
    account_id: 1,
    account_registered_participants_only: false,
    account_relationship: 2,
    alone_on_account_with_teams_enabled: false,
    custom_keywords: false,
    email: 'foo@bar.com',
    first_name: `User ${userCount}`,
    id: userCount,
    last_name: 'Bar',
    login: 'foobar',
    participant_id: 1,
    participant_reporting: true,
    pinned_polls_enabled: true,
    requires_paid_participation: false,
    service_area_id: 1,
    teams_enabled: false,
    template_poll_id: -1,
    unverified: true
  }, attrs)
}
